// FIXME: SessionのUserの型定義を用意して参照したい
type User = any;

type PermissionType =
  | 'stress_check_access'
  | 'stress_check_get_personal_result_detail'
  | 'regular_health_checkup_access'
  | 'user_manage_list_users'
  | 'user_manage_edit_stress_check_roles'
  | 'user_manage_edit_regular_health_checkup_roles'
  | 'user_manage_edit_user_manage_roles'
  | 'user_manage_add_user'
  | 'user_manage_add_lms_user'
  | 'user_manage_delete_user'
  | 'physician_introduction';

export const hasPermission = (user: User, requiredPermission: PermissionType): boolean => {
  return user?.roles.some((role: { permissions: PermissionType[] }) => role.permissions.includes(requiredPermission));
};
